import HeaderAdmin from '../components/HeaderAdmin';
import LeftSideBarAdmin  from '../components/LeftSideBarAdmin';
import 'react-toastify/dist/ReactToastify.css';
function AdministratorLayout({children}) {
    return (
        <main className='main'>
            <LeftSideBarAdmin />
            <HeaderAdmin />
            <div className='content'>{children}</div>
        </main>
    )
}
export default AdministratorLayout;